import { render } from "./MsOutlookTab.vue?vue&type=template&id=7be0b9db&lang=pug"
import script from "./MsOutlookTab.vue?vue&type=script&lang=js"
export * from "./MsOutlookTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__